import { render, staticRenderFns } from "./tableCom.vue?vue&type=template&id=9fc77a2a&scoped=true&"
import script from "./tableCom.vue?vue&type=script&lang=js&"
export * from "./tableCom.vue?vue&type=script&lang=js&"
import style0 from "./tableCom.vue?vue&type=style&index=0&id=9fc77a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc77a2a",
  null
  
)

export default component.exports